import { lazy } from "react";

const ClientStatus = lazy(() => import("./ClientStatus"));
const AddClient = lazy(() => import("./AddClient"));
const EditClient = lazy(() => import("./EditClient"));
const ClientInvitations = lazy(() => import("./ClientInvitations"));
const clientsRoutes = [
  { path: "/clients", element: <ClientStatus /> },
  { path: "/clients/add", element: <AddClient /> },
  { path: "/clients/edit/:id", element: <EditClient /> },
  { path: "/clients/invitations", element: <ClientInvitations /> }

];

export default clientsRoutes;
